import type { TFormValuesResult } from '.';

export function getDefaultFormValues(): TFormValuesResult {
  return {
    isEnabled: { isDefault: true, value: true },
    isMandatory: { isDefault: true, value: true },
    label: { isDefault: true, value: '' },
    labelLeft: { isDefault: true, value: '' },
    labelRight: { isDefault: true, value: '' },
    unit: { isDefault: true, value: '' },
    placeholder: { isDefault: true, value: '' },
    helpText: { isDefault: true, value: '' },
    min: { isDefault: true, value: 0 },
    max: { isDefault: true, value: 10 },
    step: { isDefault: true, value: 1 },
  };
}
